<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog_status" class="dialog-container"
      scrollable max-width="600px">
      <v-card>
        <v-card-title class="card-title">
          <span>프로젝트 공개하기</span>
          <div id="share-switch" v-if="!emails.length">
            <v-switch
              v-model="is_shared"
              :label="share_label"
              inset
            ></v-switch>
          </div>

        </v-card-title>

        <v-card-text v-if="!is_shared">
          <div>
            상단 오른쪽 토글로 프로젝트를 공개하시면 게스트를 초대할 수 있습니다.
          </div>
        </v-card-text>

        <v-card-text>
          <div class="card-text">게스트 이메일</div>
          <v-combobox :disabled="!is_shared"
            dense outlined
            v-model="emails"
            append-icon=null
            small-chips
            persistent-hint
            multiple
            hint="이메일을 입력후 엔터(enter)키를 눌러주세요. 엔터키로 여러 게스트를 구분할 수 있습니다."
            >
            <template v-slot:selection="data">
              <v-chip
                :input-value="data.selected"
                outlined
                close
                @click:close="removeEmail(data.item)">
                <v-tooltip left v-if="!validate(data.item)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon left
                      color="red"
                      v-bind="attrs"
                      v-on="on">
                      mdi-alert
                    </v-icon>
                  </template>
                  <span>주소가 유효하지 않습니다.</span>
                </v-tooltip>
                <strong>{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>

          <v-list v-if="!emails.length">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ firstname }} {{ lastname }}</v-list-item-title>
                <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <div class="italic">Owner</div>
              </v-list-item-action>
            </v-list-item>
            <template v-if="!!new_guests.length">
              <v-list-item 
                v-for="(guest, index) in new_guests" :key="index">
                <v-list-item-content>
                  <v-list-item-subtitle>{{ guest.email }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <div class="italic" v-if="guest.response==0">수락 대기</div>
                  <div class="italic" v-else>수락 완료</div>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn icon @click="removeGuest(guest)"><v-icon>mdi-close</v-icon></v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
            
          </v-list>

          <v-flex xs12 v-else>
            <div class="card-text">메시지</div>
            <v-textarea outlined dense
              v-model="message"
              persistent-hint
              hint="메일로 전송할 메시지를 입력해주세요.">
            </v-textarea>
          </v-flex>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="italic pending" v-if="!emails.length&&pending">저장 대기 중</div>
          <v-btn v-if="!emails.length&&pending"
            text color="primary" @click="close()">
            취소
          </v-btn>
          <v-btn v-if="!emails.length&&pending"
            depressed color="primary" @click="cancelInvitation()">
            완료
          </v-btn>
          <v-btn v-else-if="!emails.length"
            depressed color="primary" @click="close()">
            닫기
          </v-btn>
          <v-btn v-if="!!emails.length"
            text color="primary" @click="emails=[]">
            취소
          </v-btn>
          <v-btn v-if="!!emails.length" :disabled="!message"
            depressed color="primary" @click="send()">
            전송
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      is_shared: null,
      emails: [],
      message: "",
      new_guests: [],
    }
  },

  async created() {
    try {
      await this.$store.dispatch('invite/getGuests', this.$route.params.id)
    } finally {
      this.new_guests = JSON.parse(JSON.stringify(this.$store.getters['invite/guests']))
    }
  },

  computed: {
    ...mapGetters({
      firstname: 'user/firstname',
      lastname: 'user/lastname',
      email: 'user/email',
      guests: 'invite/guests',
      project_info: 'project/project_info',
    }),

    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    share_label() {
      return this.is_shared ? '공개' : '비공개'
    },

    pending() {
      return this.new_guests.length != this.guests.length
    },
  },

  watch: {
    is_shared: {
      async handler(val, old_val) {
        if (old_val!==null) {
          let old_mode = this.$store.getters['project/project_info'].mode
          let new_mode = old_mode < 10 ? 11 : 1
          await this.$store.dispatch('project/updateProject', {
            proj_id: this.$route.params.id,
            mode: new_mode
          })
        }
      },
    },

    project_info(val) {
      let mode = val.mode
      this.is_shared = mode >= 10 ? true : false
    },

    guests: {
      handler(val) {
        this.new_guests = JSON.parse(JSON.stringify(this.$store.getters['invite/guests']))
      },
      deep: true,
    },

    emails: {
      handler(val) {
        let test_array = (JSON.parse(JSON.stringify(this.guests))).map(v => v.email)
        test_array.push(this.email)
        let duplicates = val.filter(v => test_array.includes(v))
        if (!!duplicates.length) {
          this.emails = val.filter(v => !test_array.includes(v))
        }
      },
      deep: true
    }
  },

  methods: {
    close() {
      this.new_guests = JSON.parse(JSON.stringify(this.$store.getters['invite/guests']))
      this.emails = []
      this.message = ""
      this.$emit('update:dialog', false)
    },
    
    removeEmail(item) {
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },

    validate(v) {
        if (!(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v))) {
            return false;
        } else {
            return true;
        }
     },

     async send() {
       try {
        await this.$store.dispatch('invite/inviteGuests', {
          proj_id: this.$route.params.id,
          guests: this.emails,
          message: this.message,
        })
       } finally {
         this.emails = []
         this.message = ""
         this.close()
       }
     },

     removeGuest(item) {
       this.new_guests.splice(this.new_guests.indexOf(item), 1)
       this.new_guests = [...this.new_guests]
     },

     async cancelInvitation() {
       let old_ids = this.guests.map(v=>v.guest_id)
       let new_ids = this.new_guests.map(v=>v.guest_id)
       let cancel_ids = old_ids.filter(v=>!new_ids.includes(v))
       try {
         await this.$store.dispatch('invite/cancelInvitingGuests', {
           proj_id: this.$route.params.id,
           guests: cancel_ids
         })
       } finally {
         this.close()
       }
     },
  },
}
</script>

<style scoped>
  .card-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  #share-switch {
    transform:translateY(10px)
  }

  .italic {
    font-style: italic;
  }

  .pending {
    margin-right: 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/modal/project/ShareProject.vue